module.exports = __webpack_public_path__ + "static/media/facebook-icon.f0749264.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/social-icons/facebook-icon.svg
// module id = 422
// module chunks = 0